__turbopack_context__.v({
  "root": "BaseLabel-module__2n_ZtW__root",
});
